import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { getIdProvider } from "../../../../util/IDProvider";
import { AlertError } from "../StandardAlerts/StandardAlerts";
const ErrorList = (props) => {
    const { errors } = props;
    const errorsKeyProvider = getIdProvider();
    return (_jsx(_Fragment, { children: errors && errors.length > 0 && (_jsxs(_Fragment, { children: [_jsx("button", { className: "btn btn-link", onClick: () => {
                        props.onClear();
                    }, children: "Hide" }), errors.map((e) => (_jsx(AlertError, { className: props.errorDetailClassName, message: e.message, detail: e.detail }, errorsKeyProvider.getAndIncrement())))] })) }));
};
export default ErrorList;
